<template>
    <div id="coloroverview">
        <div class="card colors-list">
            <div class="card-content">
                <div class="productoverviewline top-buttons">
                    <ui5-button
                        @click="exportColors"
                        v-if="hasRight('administration')"
                    >
                        {{ trans('pages.color_overview.export_colors') }}
                    </ui5-button>
                    <ui5-button
                        @click="$router.push('/addcolorpage')"
                        v-if="hasRight('productionmanagement')"
                    >
                        {{ trans('pages.color_overview.new_color') }}
                    </ui5-button>
                </div>

                <crm-table
                    v-if="initialFilters"
                    ref="colorTable"
                    :use-global-scroll="true"
                    :columns="columns"
                    :items="colors"
                    :count="colors.length + 1"
                    :status="status"
                    @fetch="onFetch"
                    :default-filters="initialFilters"
                    default-sort="createdAt"
                    default-order="desc"
                    :has-sticky="false"
                >
                    <template v-slot:no-results>
                        {{ trans('pages.color_overview.no_results') }}
                    </template>
                    <template v-slot:actions="props">
                        <td>
                            <div>
                                <i
                                    class="fa fa-info-circle"
                                    @click="loadColorPage(props.item)"
                                />
                            </div>
                        </td>
                    </template>
                    <template v-slot:sort="props">
                        <td>
                            <text-input
                                v-model="props.item.sort"
                                :placeholder="
                                    trans(
                                        'pages.color_overview.sorting_placeholder'
                                    )
                                "
                                type="number"
                                min="0"
                                max="10"
                                :class="props.item.sortClasses"
                                @blur="updateSort(props.item)"
                            />
                        </td>
                    </template>
                </crm-table>
            </div>
        </div>
    </div>
</template>
<script>
import Spinner from '../components/loader/Spinner';
import CrmTable from '../components/CrmTable';
import TextInput from '../components/TextInput';
import AutoCompleteInput from '../components/AutoCompleteInput';
import colorApi from '../api/color';
import { mapGetters } from 'vuex';
import { showErrorMessage } from '../dialogs';
import localization from '../mixins/localization';

export default {
    components: { Spinner, CrmTable, TextInput, AutoCompleteInput },
    mixins: [localization],
    data() {
        return {
            initialFilters: null,
            status: 'running',
            colors: [],
            columns: [
                {
                    name: 'actions',
                    label: this.trans('pages.color_overview.actions'),
                },
                {
                    name: 'ralnr',
                    label: this.trans('pages.color_overview.ral_nr'),
                    searchable: true,
                    sortable: false,
                },
                {
                    name: 'raltype',
                    label: this.trans('pages.color_overview.ral_type'),
                    searchable: true,
                    sortable: false,
                },
                {
                    name: 'poedernr',
                    label: this.trans('pages.color_overview.powder_nr'),
                    searchable: true,
                    sortable: false,
                },
                {
                    name: 'poedernr2',
                    label: this.trans('pages.color_overview.powder_nr2'),
                    searchable: true,
                    sortable: false,
                },
                {
                    name: 'poedernr3',
                    label: this.trans('pages.color_overview.powder_nr3'),
                    searchable: true,
                    sortable: false,
                },
                {
                    name: 'description',
                    label: this.trans('pages.color_overview.description'),
                    searchable: true,
                    sortable: false,
                },
                {
                    name: 'producent',
                    label: this.trans('pages.color_overview.producer'),
                    searchable: true,
                    sortable: false,
                },
                {
                    name: 'tendon',
                    label: this.trans('pages.color_overview.tendon'),
                    searchable: true,
                    sortable: false,
                },
                {
                    name: 'sort',
                    label: this.trans('pages.color_overview.sorting'),
                    searchable: false,
                    sortable: false,
                },
            ],
        };
    },
    computed: {
        ...mapGetters({
            hasRight: 'currentUser/hasRight',
        }),
    },
    methods: {
        onFetch(filters) {
            if (filters.page === 1) {
                this.colors = [];
            }
            this.status = 'running';

            const limit = 50;
            // Ensure filters.page is a valid positive number
            const pageNumber = parseInt(filters.page, 10);
            const page = !isNaN(pageNumber) && pageNumber > 0 ? pageNumber - 1 : 0;

            const payload = {
                ...filters,
                page,
                limit,
            };

            this.$store.commit('colorOverview/setFilters', filters, {
                root: true,
            });

            colorApi
                .list(payload)
                .then((response) => {
                    const colors = response.data.data;

                    colors.forEach((item) => {
                        item.sortClasses = {};
                    });

                    if (!this.colors) {
                        this.colors = [];
                    }

                    colors.forEach((color) => {
                        if (!this.colors.find((x) => x.id == color.id)) {
                            this.colors.push(color);
                        }
                    });

                    this.status = 'success';
                })
                .catch((err) => {
                    if (!axios.isCancel(err)) {
                        this.status = 'error';
                    }
                });
        },
        loadColorPage(color) {
            this.$router.push('/colorpage/' + color.id);
        },
        exportColors() {
            window.open(colorApi.export());
        },
        updateSort(color) {
            const sort = color.sort;

            color.sortClasses = {};

            if (sort !== '' && !isNaN(sort) && sort >= 0 && sort <= 10) {
                colorApi
                    .updateSort(color.id, sort)
                    .then(() => {
                        color.sortClasses = { inputsuccess: true };
                    })
                    .catch(() => {
                        color.sortClasses = { inputerror: true };
                    });
            } else {
                showErrorMessage(
                    this.trans('pages.color_overview.sorting_error')
                );
                color.sortClasses = { inputerror: true };
            }
        },
        fetchMore() {
            this.$refs.colorTable.fetch(true);
        },
    },
    mounted() {
        this.initialFilters = this.$store.getters['colorOverview/getFilters'];
    },
};
</script>
